import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import FeatureHighlight from "@/components/wpl/feature-highlight/src";

const container = css({
    "@media (min-width: 48rem) and (max-width: 63.99rem)": {
        maxWidth: "800px",
        margin: "0 auto"
    }
});

const FeaturesSection = () => {
    const intl = useIntl();

    const featureCards = [
        {
            title: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.start-with-page.title",
                defaultMessage: "Start with a page"
            }),
            body: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.start-with-page.body",
                defaultMessage:
                    "Plan projects, take notes, and brainstorm. Let AI write your first draft."
            }),
            contentSrc:
                "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence-create-a-page.webp"
        },
        {
            title: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.share-with-teams.title",
                defaultMessage: "Share with your teams"
            }),
            body: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.share-with-teams.body",
                defaultMessage:
                    "Invite your teams to collaborate using real-time editing and inline comments."
            }),
            contentSrc:
                "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence-share-it-with-your-team.webp"
        },
        {
            title: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.connect-work.title",
                defaultMessage: "Connect all your work"
            }),
            body: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.connect-work.body",
                defaultMessage:
                    "Stay organized in dedicated workspaces, equipped with AI-powered search."
            }),
            contentSrc:
                "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence-organize-your-work.webp"
        }
    ];

    return (
        <div css={container}>
            <FeatureHighlight
                background="lightblue"
                cardVerticalLayout="below"
                mediaType="image"
                transparentBackground
                barColor="p100"
                cards={featureCards}
            />
        </div>
    );
};

export default FeaturesSection;
